module.exports = __webpack_public_path__ + "img/Vector.d6e5a9ea.png";